// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__2rDJB","link":"Navigation_link__1d7uP","activeLink":"Navigation_activeLink__25aSm"};